<script setup lang="ts">
import IconSvgBase from '~theme/components/atoms/icons/IconSvgBase.vue';
</script>

<template>
  <IconSvgBase :class="$style.path" :view-width="16" :view-height="16">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0007 6.66667C12.0007 6.29933 11.702 6 11.334 6C10.966 6 10.6673 6.29933 10.6673 6.66667C10.6673 7.034 10.966 7.33333 11.334 7.33333C11.702 7.33333 12.0007 7.034 12.0007 6.66667ZM13.334 6.66667C13.334 7.76933 12.4367 8.66667 11.334 8.66667C10.2313 8.66667 9.33398 7.76933 9.33398 6.66667C9.33398 5.564 10.2313 4.66667 11.334 4.66667C12.4367 4.66667 13.334 5.564 13.334 6.66667ZM7.33398 4.66667C7.33398 3.93133 6.73598 3.33333 6.00065 3.33333C5.26532 3.33333 4.66732 3.93133 4.66732 4.66667C4.66732 5.402 5.26532 6 6.00065 6C6.73598 6 7.33398 5.402 7.33398 4.66667ZM8.66732 4.66667C8.66732 6.13733 7.47132 7.33333 6.00065 7.33333C4.52998 7.33333 3.33398 6.13733 3.33398 4.66667C3.33398 3.196 4.52998 2 6.00065 2C7.47132 2 8.66732 3.196 8.66732 4.66667ZM9.29398 10.0307C9.87332 9.58267 10.5867 9.33333 11.334 9.33333C13.172 9.33333 14.6673 10.8287 14.6673 12.6667C14.6673 13.0347 14.3693 13.3333 14.0007 13.3333C13.632 13.3333 13.334 13.0347 13.334 12.6667C13.334 11.564 12.4367 10.6667 11.334 10.6667C10.8787 10.6667 10.446 10.8227 10.0967 11.0993C10.4593 11.7633 10.6673 12.5247 10.6673 13.3333C10.6673 13.7013 10.3693 14 10.0007 14C9.63198 14 9.33398 13.7013 9.33398 13.3333C9.33398 11.4953 7.83865 10 6.00065 10C4.16265 10 2.66732 11.4953 2.66732 13.3333C2.66732 13.7013 2.36932 14 2.00065 14C1.63198 14 1.33398 13.7013 1.33398 13.3333C1.33398 10.76 3.42798 8.66667 6.00065 8.66667C7.28532 8.66667 8.44932 9.18867 9.29398 10.0307Z"
    />
  </IconSvgBase>
</template>

<style lang="scss" module>
.path {
  width: 1em;
  height: 1em;
  stroke: currentColor;
  fill: currentColor;
}
</style>
